// Video file formats
export const VIDEO_FORMATS = ['.mp4', '.webm', '.mkv', '.avi'] as const;

// Orthophoto file formats
export const ORTHOPHOTO_FORMATS = ['.tif', '.tiff', '.jp2'] as const;

// Point cloud file formats
export const POINT_CLOUD_FORMATS = ['.las', '.laz', '.e57'] as const;

// Check if extension is a video format (accepts with or without leading dot)
export function isVideoExtension(extension: string): boolean {
    const normalized = extension.toLowerCase().startsWith('.') ? extension.toLowerCase() : `.${extension.toLowerCase()}`;
    return VIDEO_FORMATS.includes(normalized as (typeof VIDEO_FORMATS)[number]);
}

// Check if filename has a video extension
export function isVideoFile(filename: string): boolean {
    const ext = getFileExtension(filename);
    return isVideoExtension(ext);
}

// Get file extension with leading dot
export function getFileExtension(filename: string): string {
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1) return '';
    return filename.substring(lastDot).toLowerCase();
}

// Get video extensions without leading dot (e.g., ['mp4', 'webm', ...])
export function getVideoExtensionsWithoutDot(): string[] {
    return VIDEO_FORMATS.map(ext => ext.substring(1));
}
